/**
 * The weekly faucet's post, worded by the owner and shared by the client (what the player posts) and the server
 * (what the verification expects): one place, so the two cannot drift. Pure strings, no DOM, no node.
 *
 * Blockari's `share/faucet-layout.ts` wording (17aabed), with `#21Wild`. The TWO spaces after "realchaingames."
 * are the owner's and are kept exactly; X renders them as a non-breaking space and the verification does not
 * depend on them.
 */

/** The hashtag and the account the post must carry. */
export const FAUCET_HASHTAG = '#21Wild';
export const FAUCET_MENTION = '@realchaingames';

/** The post's text without the link (the share sheet's `text`, the intent URL's `text`). */
export function faucetShareText(amount: number): string {
  return `I just got ${amount} free tokens to play ${FAUCET_HASHTAG} from ${FAUCET_MENTION}.  Get your ${amount} free tokens to start playing today!`;
}

/** The post, then the personal link after one space: what a native share sheet gets as its `text` (no `url` key). */
export function faucetPostText(amount: number, url: string): string {
  return `${faucetShareText(amount)} ${url}`;
}

/** The desktop fallback: X's post composer with the text and the link (its card unfurls the image). */
export function faucetIntentUrl(amount: number, url: string): string {
  return `https://x.com/intent/post?text=${encodeURIComponent(faucetShareText(amount))}&url=${encodeURIComponent(url)}`;
}

/** The link as printed on the card: no scheme, like the score cards' host. */
export function faucetDisplayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '');
}
